import { ChatfuelBroadcastRequest, UserAttributes } from '@global/utils/chat/chatfuel';
import { ChatfuelBlockNames } from '@global/utils/chat/chatfuel-blocks-types';

export const buildChatfuelBroadcastRequest = (
  userId: string,
  blockName?: ChatfuelBlockNames,
  userAttributes?: UserAttributes
): ChatfuelBroadcastRequest => {
  return {
    blockName,
    userAttributes,
    user: userId,
  };
};
